import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-trash',
	templateUrl: './icon-trash.component.svg',
})
export class IconTrashComponent {}
